import dados from '@/dados/dados.js'
import g from '@/softam/geral.js'

export default {
    name: 'mvitrine',
    data() {
        return{
            retorno:[],
            respostaJSON: []
        }
    },
    async recuperarGrupos(area) {

        await dados.ler('Vitrine/RecuperarGrupos',{area: area}).then(r => {
            let resposta = JSON.parse(r.data);
            let i = 1;
            resposta.forEach(e => {
                if (e.imagem == ""){
                    e.imagem = "semimagem.jpg";
                }
                e.imagem = "http://www.infoassuf.com.br/ImagensArtigos/" + e.imagem;
                e.classe = "item" + (i%2);

                i++;
            });
            this.retorno = resposta;
        }).catch(error =>{
            console.log(error.response);
            throw error;
        })

    },
    async recuperarGruposEstoque() {

        await dados.ler('Vitrine/RecuperarGruposEstoque',{}).then(r => {
            var resposta = JSON.parse(r.data);
            this.retorno = resposta;
        }).catch(error =>{
            throw error;
        })

    },
    async recuperarReferencias(area,codgrupo) {

        await dados.ler('Vitrine/RecuperarReferencias',{area: area, codgrupo:codgrupo}).then(r => {
            var resposta = JSON.parse(r.data);
            resposta.forEach(e => {
                if (e.imagem == ""){
                    e.imagem = "semimagem.jpg";
                }
                e.peca = e.imagem.split('.')[0];
                e.imagem = "http://www.infoassuf.com.br/ImagensArtigos/" + e.imagem;
                e.preco = "R$ " + g.formatarF(e.preco);
                e.precopromocao = "R$ " + g.formatarF(e.precopromocao);
                
            });
            this.retorno = resposta;
        }).catch(error =>{
            console.log(error.response);
            throw error;
        })

    },
    async recuperarReferenciasLivre(criterio) {

        await dados.ler('Vitrine/RecuperarReferenciasLivre',{criterio: criterio}).then(r => {
            var resposta = JSON.parse(r.data);
            resposta.forEach(e => {
                if (e.imagem == ""){
                    e.imagem = "semimagem.jpg";
                }
                e.imagem = "http://www.infoassuf.com.br/ImagensArtigos/" + e.imagem;
                console.log(e.imagem);
                e.preco = "R$ " + g.formatarF(e.preco);
                
            });
            this.retorno = resposta;
        }).catch(error =>{
            console.log(error.response);
            throw error;
        })

    },
    async recuperarReferencia(id) {

        await dados.ler('Vitrine/RecuperarReferencia',{id:id}).then(r => {
            var resposta = JSON.parse(r.data);
            resposta.forEach(e => {
                e.numero = e.imagem.split(".")[0];
                e.imagem = (e.imagem == "" ? "semimagem.jpg" : e.imagem );
                e.imagem = "http://www.infoassuf.com.br/ImagensArtigos/" + e.imagem;
                e.preco = "R$ " + g.formatarF(e.preco);
                
            });
            this.retorno = resposta[0];
        }).catch(error =>{
            throw error;
        })

    },
    async atualizarSaldoReferencias(){
        await dados.ler('Vitrine/AtualizarSaldoReferencias',{}).then(() => {
            this.retorno = "{}";
        }).catch(error =>{
            throw error;
        })

    }

}